$(function () {
    $('.js-eventSearch').each(function () {
        var $this = $(this);
        var widgetId = $this.attr('data-id');
        // read query string and set form values
        var startDate = getParameterByName('startdate');
        if (startDate) {
            $('#eventSearch-startDate-' + widgetId).val(startDate);
        }
        var endDate = getParameterByName('enddate');
        if (endDate) {
            $('#eventSearch-endDate-' + widgetId).val(endDate);
        }
        var keywords = getParameterByName('keywords');
        if (keywords) {
            $('#eventSearch-keywordText-' + widgetId).val(keywords);
        }
        var types = getParameterByName('types');
        if (types) {
            typeItems = types.split(',');
            if (typeItems.length > 0) {
                $('#eventSearch-typeList-' + widgetId).val(typeItems[0].replace("&", "&amp;"));
            }
        }
        var cities = getParameterByName('cities');
        if (cities) {
            cityItems = cities.split(',');
            if (cityItems.length > 0) {
                $('#eventSearch-cityList-' + widgetId).val(cityItems[0]);
            }
        }
    });

    // process form when search is clicked
    $('.js-eventSearch-submit').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var widgetId = $this.attr('data-id');
        processForm(widgetId);
    });

    // process form when enter key is pressed when keyword textbox in focus
    $('.js-eventSearch-keyword').keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            var $this = $(this);
            var widgetId = $this.attr('data-id');
            processForm(widgetId);
        }
    });
});

function processForm(widgetId) {
    var url = "";
    var queryStringItems = new Array();
    var eventSearchResultsPage = $('#eventSearch-searchButton-' + widgetId).attr('href');
    var startDate = $('#eventSearch-startDate-' + widgetId).val();
    var endDate = $('#eventSearch-endDate-' + widgetId).val();
    var keyword = $('#eventSearch-keywordText-' + widgetId).val();
    var typeSelected = $('#eventSearch-typeList-' + widgetId).find(":selected").val();
    var citySelected = $('#eventSearch-cityList-' + widgetId).find(":selected").val();

    url = url + eventSearchResultsPage;
    if (startDate.length > 0) {
        queryStringItems.push("startdate=" + startDate);
    }
    if (endDate.length > 0) {
        queryStringItems.push("enddate=" + endDate);
    }
    if (keyword.length > 0) {
        queryStringItems.push("keywords=" + keyword);
    }
    if (typeSelected.length > 0) {
        // have to encode ampersands to %26 within the value or JS to get query string values will break
        queryStringItems.push("types=" + typeSelected.replace("&amp;", "%26"));
    }
    if (citySelected.length > 0) {
        queryStringItems.push("cities=" + citySelected);
    }
    if (queryStringItems.length > 0) {
        url = url + "?" + queryStringItems.join("&");
    }
    window.location.href = url;
}

function clearEventSearchFormElements(widgetId) {
    $("#eventSearch-" + widgetId).find(':input').each(function () {
        $(this).val('');
    });
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}